import React from "react";
import { connect } from "react-redux";
import get from "lodash/get";
import PropTypes from "prop-types";
import { AdService } from "../../ad-service";
import { updateBodyScroll } from "../../../utils";

class FooterBase extends React.Component {
  constructor(props) {
    super(props);
    this.footerElement = null;
  }

  componentDidMount() {
    this.initializeObserver();
  }

  componentDidUpdate(prevProp) {
    const prevMonogramUrl = get(prevProp, ["publisherTheme", "monogram"], "");
    const monogramUrl = get(this.props, ["publisherTheme", "monogram"], "");

    if (prevMonogramUrl !== monogramUrl) {
      this.setState({
        monogramUrl
      });
    }
  }

  initializeObserver() {
    this.footerLogoObserver = new IntersectionObserver((entries, observer) => this.setMonogramUrl(entries, observer), {
      rootMargin: "0px",
      threshold: 1.0
    });
    this.footerLogoObserver.observe(this.footerElement);
  }

  setMonogramUrl(entries, observer) {
    const entry = get(entries, [0], {});
    const monogramUrl = get(this.props, ["publisherTheme", "monogram"], "");
    entry.isIntersecting &&
      this.setState({ monogramUrl }, () => this.footerLogoObserver && this.footerLogoObserver.disconnect());
  }

  closeAll = () => {
    updateBodyScroll(false, "remove-body-scroll-header");
    this.props.closeAll();
  };

  footerElement = () => {
    this.footerElement = null;
  };

  render() {
    return (
      <div ref={el => (this.footerElement = el)}>
        <div className="app-ad app-ad--leaderboard">
          <AdService adtype="Horizontal-Ad" layoutName="Navigation" slotId="Footer-Leaderboard-Ad" />
        </div>
        {this.props.renderTemplate(
          Object.assign({}, this.props, this.state),
          this.closeAll,
          this.footerElement,
          this.props.socialFollowStyle,
          this.props.enableAccesstype,
          this.props.enableAppDownloadLinks,
          this.props.appStoreDownloadLink,
          this.props.googlePlayDownloadLink
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    title: get(state.qt, ["config", "publisher-settings", "title"], "Madrid"),
    menu: get(state.qt, ["data", "navigationMenu"], []),
    domainSlug: get(state.qt, ["config", "domainSlug"], ""),
    publisherTheme: get(state.qt, ["config", "theme-attributes"], {}),
    publisherSettings: get(state, ["qt", "config", "publisher-settings"], {}),
    footerPageBuilderConfig: get(state, ["qt", "config", "pagebuilder-config", "footer"], {}),
    publisherName: get(state.qt, ["config", "publisher-name"], "Madrid"),
    socialLinks: get(state.qt, ["config", "social-links"], {}),
    footer: state.footer || {},
    footerLogoUrl: get(
      state.qt,
      ["config", "pagebuilder-config", "footer", "logo"],
      get(state.qt, ["config", "theme-attributes", "monogram"], "")
    ),
    enableAccesstype: get(
      state.qt,
      ["config", "pagebuilder-config", "footer", "enableSubscriptionButton"],
      get(state.qt, ["config", "theme-attributes", "enableAccesstype"], false)
    ),
    enableAppDownloadLinks: get(
      state.qt,
      ["config", "pagebuilder-config", "footer", "enableAppDownloadLinksButton"],
      false
    ),
    appStoreDownloadLink: get(
      state.qt,
      ["config", "pagebuilder-config", "general", "appDownloadLinks", "appStoreDownloadLink"],
      ""
    ),
    googlePlayDownloadLink: get(
      state.qt,
      ["config", "pagebuilder-config", "general", "appDownloadLinks", "googlePlayDownloadLink"],
      ""
    ),
    socialFollowStyle: get(
      state.qt,
      ["config", "pagebuilder-config", "footer", "socialFollowStyle"],
      "circular-color-svg"
    )
  };
};

FooterBase.propTypes = {
  title: PropTypes.string,
  menu: PropTypes.array,
  domainSlug: PropTypes.string,
  enableAccesstype: PropTypes.bool,
  enableAppDownloadLinks: PropTypes.bool,
  googlePlayDownloadLink: PropTypes.string,
  appStoreDownloadLink: PropTypes.string,
  socialFollowStyle: PropTypes.string,
  publisherTheme: PropTypes.shape({
    logo: PropTypes.string,
    monogram: PropTypes.string,
    footer_theme: PropTypes.string
  }),
  publisherName: PropTypes.string,
  socialLinks: PropTypes.shape({
    "facebook-url": PropTypes.string,
    "twitter-url": PropTypes.string
  }),
  closeAll: PropTypes.func,
  renderTemplate: PropTypes.func
};

const Footer = connect(mapStateToProps)(FooterBase);

export { Footer };
